<template>
  <template-dialog-wraper>
    <div class="container">
      <p class="t1">{{ $t('loginModule.title') }}</p>
      <p class="t2 mt-20">{{ $t('loginModule.loginMethod') }}</p>
      <p class="t4-regular mt-10 desc-text">{{ $t('loginModule.loginMethodTip') }}</p>
      <div class="qr-wrap mt-30">
        <img v-if="qrcodeUrl" :src="qrcodeUrl" width="160" height="160" alt="loklok skin ercode" />
        <div v-if="loginStatus == 4" class="mask-w">
          <img src="https://static.loklok.video/img/yes.png" />
        </div>
        <div v-else-if="loginStatus == 5" class="mask-w">
          <img src="https://static.loklok.video/img/warning.png" />
          <p class="mt-10">{{ $t('loginModule.codeExpired') }}</p>
          <div class="btn mt-10" @click="handleRefresh">{{ $t('loginModule.refreshButton') }}</div>
        </div>
      </div>
      <p class="t2 mt-30">
        {{ $t('loginModule.howToDownload') }}
        <nuxt-link :to="localePath('/download_nd')">
          <span class="primary-text" style="cursor: pointer" @click="$emit('close')" :data-bury-params="JSON.stringify({ UM_Key_ButtonName: '下载跳转' })">{{ $t('loginModule.clickMe') }}</span>
        </nuxt-link>
      </p>
    </div>
  </template-dialog-wraper>
</template>

<script>
import TemplateDialogWraper from '~/components/dialog/TemplateDialogWraper.vue'
import QRCode from 'qrcode'

export default {
  components: {
    TemplateDialogWraper
  },
  data() {
    return {
      qrcodeUrl: '',
      oauthKey: '',
      loginStatus: 1,
      timer: null
    }
  },
  created() {
    this.fetchQrcode()
    // QRCode.toDataURL('我是你爹').then((url) => {
    //   this.qrcodeUrl = url
    // })
  },
  methods: {
    fetchQrcode() {
      this.$api
        .loadQrcode()
        .then((res) => {
          let { url, oauthKey } = res
          this.oauthKey = oauthKey
          return QRCode.toDataURL(url)
        })
        .then((url) => {
          this.qrcodeUrl = url
          this.refreshStatus()
        })
    },
    refreshStatus() {
      this.$api.getScanState({ oauthKey: this.oauthKey }).then(async (res) => {
        //二维码状态，1-初始状态，2-扫码中，3-取消，4-确定登录，5-已过期
        this.loginStatus = res.status
        if (this.loginStatus == 1 || this.loginStatus == 2 || this.loginStatus == 3) {
          this.timer = setTimeout(() => {
            this.refreshStatus()
          }, 1000)
        } else if (this.loginStatus == 4) {
          let { jwtToken } = res
          this.$store.commit('user/SET_TOKEN', jwtToken)
          try {
            const data = await this.$api.getUserInfo(jwtToken)
            this.$store.commit('user/SET_USER', data)
            this.handleBury()
          } catch {
            this.handleBury()
          }

          this.$router.go(0)
        }
      })
    },
    // 登陆成功埋点
    handleBury() {
      this.$LokBury.handleMD(
        {
          buryEventId: 'UM_Event_LoginSuc'
        },
        'custom'
      )
    },
    handleRefresh() {
      this.loginStatus = 1
      this.fetchQrcode()
    }
  },
  destroyed() {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss" scoped>
@import '~/styles/vars.sass';
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: $mainTextColor;
  .qr-wrap {
    position: relative;
    > img {
      border-radius: 16px;
    }
    .mask-w {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5));
      border-radius: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      > img {
        width: 32px;
      }
      p {
        font-weight: bold;
        font-size: 12px;
        line-height: 150%;
        color: $mainTextColor;
      }
      .btn {
        background: $mainColor;
        border-radius: 39px;
        color: $mainTextColor;
        padding: 4px 10px;
        font-size: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>
